var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d33",
    fillRule: "nonzero",
    d: "M19.688 4.126c-2.297 0-5.966-1.936-8.4-3.85a1.26 1.26 0 0 0-1.575 0c-2.435 1.914-6.104 3.85-8.4 3.85C.588 4.126 0 4.741 0 5.501c0 7.678 3.545 13.498 9.983 16.388a1.261 1.261 0 0 0 1.034 0C17.455 18.999 21 13.179 21 5.5c0-.76-.588-1.375-1.313-1.375zM10.5 19.118v-8.117H3.434a17.25 17.25 0 0 1-.774-4.253c2.53-.447 5.525-2.01 7.84-3.68V11h7.066c-1.152 3.621-3.53 6.383-7.066 8.117z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShield);
export default __webpack_public_path__ + "static/media/ico-shield.73a70438.svg";
export { ForwardRef as ReactComponent };